// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
// import Header from '../Header/Header';
// import Footer from '../../Components/Footer/Footer';

// const PrivacyPolicy = () => {
//   return (
//     <div className="min-h-screen bg-gray-50">
//         <Header />
//       {/* Navigation Bar */}
//       <nav className="bg-white shadow-sm">
//         <div className="container mx-auto px-4 py-4">
//           <div className="flex items-center justify-between">
//             <Link to="/" className="flex items-center space-x-2 text-blue-600 hover:text-blue-700">
//               <FontAwesomeIcon icon={faArrowLeft} />
//               <span>Back to Home</span>
//             </Link>
//             <h1 className="text-xl font-bold text-gray-800">Zakku</h1>
//           </div>
//         </div>
//       </nav>

//       {/* Header */}
//       <header className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-12">
//         <div className="container mx-auto px-4 text-center">
//           <FontAwesomeIcon icon={faShieldAlt} className="text-4xl mb-4" />
//           <h1 className="text-3xl md:text-4xl font-bold mb-3">Privacy Policy</h1>
//           <p className="text-lg opacity-90">Your privacy matters to Zakku</p>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="container mx-auto px-4 py-8 max-w-4xl">
//         <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
//           {/* Introduction */}
//           <section className="mb-8">
//             <p className="text-gray-700 leading-relaxed">
//               At <strong className="text-blue-600">Zakku</strong>, we are committed to protecting your privacy.
//               This Privacy Policy explains how we collect, use, and safeguard your
//               information when you use our furniture delivery platform.
//             </p>
//           </section>

//           {/* Section 1 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               1. Information We Collect
//             </h2>
//             <p className="text-gray-700 mb-3">We may collect the following types of information:</p>
//             <ul className="list-disc pl-6 text-gray-700 space-y-2">
//               <li>Personal details such as name, phone number, email address, and delivery address</li>
//               <li>Order and transaction details</li>
//               <li>Payment-related information (processed securely by third-party providers)</li>
//               <li>Device and usage data such as browser type and IP address</li>
//             </ul>
//           </section>

//           {/* Section 2 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               2. How We Use Your Information
//             </h2>
//             <p className="text-gray-700 mb-3">Your information is used to:</p>
//             <ul className="list-disc pl-6 text-gray-700 space-y-2">
//               <li>Process and deliver furniture orders</li>
//               <li>Communicate order updates and customer support</li>
//               <li>Improve our platform, services, and user experience</li>
//               <li>Ensure security and prevent fraud</li>
//             </ul>
//           </section>

//           {/* Section 3 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               3. Sharing of Information
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               Zakku does not sell or rent your personal information. We may share
//               data only with trusted partners such as delivery providers and payment
//               gateways, strictly for service fulfillment.
//             </p>
//           </section>

//           {/* Section 4 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               4. Data Security
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               We implement appropriate technical and organizational measures to
//               protect your personal data from unauthorized access, loss, or misuse.
//             </p>
//           </section>

//           {/* Section 5 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               5. Cookies
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               Our website may use cookies to enhance functionality and analyze usage.
//               You can control cookie preferences through your browser settings.
//             </p>
//           </section>

//           {/* Section 6 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               6. Your Rights
//             </h2>
//             <p className="text-gray-700 mb-3">You have the right to:</p>
//             <ul className="list-disc pl-6 text-gray-700 space-y-2">
//               <li>Access and review your personal information</li>
//               <li>Request corrections or updates</li>
//               <li>Request deletion of your data, subject to legal obligations</li>
//             </ul>
//           </section>

//           {/* Section 7 */}
//           <section className="mb-8">
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               7. Policy Updates
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               Zakku may update this Privacy Policy from time to time. Any changes
//               will be posted on this page with an updated effective date.
//             </p>
//           </section>

//           {/* Section 8 */}
//           <section>
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
//               8. Contact Us
//             </h2>
//             <p className="text-gray-700 leading-relaxed">
//               If you have questions or concerns about this Privacy Policy, please
//               contact us at <strong className="text-blue-600">support@zakku.com</strong>.
//             </p>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />
//     </div>
//   );
// };

// export default PrivacyPolicy;








import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faArrowLeft, 
  faShieldAlt, 
  faUserShield,
  faCreditCard,
  faTruck,
  faStore,
  faLock
} from '@fortawesome/free-solid-svg-icons';
import Header from '../Header/Header';
import Footer from '../../Components/Footer/Footer';

const PrivacyPolicy = () => {
  const lastUpdated = "December 1, 2023";
  
  return (
    <div className="min-h-screen bg-gray-50">
      
      
      {/* Navigation Bar */}
      <nav className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 text-blue-600 hover:text-blue-700 transition-colors duration-200">
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Back to Home</span>
            </Link>
            <div className="flex items-center space-x-2">
              <FontAwesomeIcon icon={faUserShield} className="text-blue-600" />
              <h1 className="text-xl font-bold text-gray-800">Zakku - Furniture Marketplace</h1>
            </div>
          </div>
        </div>
      </nav>

      {/* Header */}
      <header className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-12">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full">
              <FontAwesomeIcon icon={faShieldAlt} className="text-4xl" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-3">Privacy Policy</h1>
          <p className="text-lg opacity-90 mb-2">Protecting Your Privacy in Our Furniture Marketplace</p>
          <div className="inline-flex items-center space-x-2 bg-white/10 px-4 py-2 rounded-full mt-2">
            <FontAwesomeIcon icon={faLock} className="text-sm" />
            <span className="text-sm">Last Updated: {lastUpdated}</span>
          </div>
        </div>
      </header>

      {/* Quick Summary */}
      <div className="container mx-auto px-4 max-w-4xl -mt-6">
        <div className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-lg shadow-xl p-6 mb-8">
          <h2 className="text-xl font-bold mb-3">Quick Summary</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-white/10 p-4 rounded-lg">
              <FontAwesomeIcon icon={faStore} className="text-xl mb-2" />
              <h3 className="font-semibold">Seller & Buyer Platform</h3>
              <p className="text-sm opacity-90">Connecting furniture sellers with buyers</p>
            </div>
            <div className="bg-white/10 p-4 rounded-lg">
              <FontAwesomeIcon icon={faCreditCard} className="text-xl mb-2" />
              <h3 className="font-semibold">Secure Payments</h3>
              <p className="text-sm opacity-90">Razorpay & Cash on Delivery</p>
            </div>
            <div className="bg-white/10 p-4 rounded-lg">
              <FontAwesomeIcon icon={faTruck} className="text-xl mb-2" />
              <h3 className="font-semibold">Safe Transactions</h3>
              <p className="text-sm opacity-90">Verified sellers & secure delivery</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
          
          {/* Introduction */}
          <section className="mb-10">
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg mb-6">
              <h2 className="text-lg font-bold text-gray-900 mb-2">Welcome to Zakku</h2>
              <p className="text-gray-700">
                Zakku is a peer-to-peer furniture marketplace where independent sellers can list their furniture 
                and buyers can purchase items. Your privacy is critically important to us in maintaining this 
                trusted community.
              </p>
            </div>
          </section>

          {/* Section 1 - Updated for Marketplace */}
          <section className="mb-10">
            <div className="flex items-center mb-4">
              <div className="bg-blue-100 p-3 rounded-lg mr-4">
                <FontAwesomeIcon icon={faUserShield} className="text-blue-600 text-lg" />
              </div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                1. Information We Collect in Our Marketplace
              </h2>
            </div>
            <div className="bg-gray-50 p-5 rounded-lg">
              <h3 className="font-semibold text-gray-800 mb-3">From All Users:</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Account information: name, email, phone number, profile picture</li>
                <li>Contact details: shipping and billing addresses</li>
                <li>Device information: IP address, browser type, operating system</li>
                <li>Usage data: pages visited, searches made, time spent on platform</li>
              </ul>

              <h3 className="font-semibold text-gray-800 mb-3">From Sellers:</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
                <li>Business information (if applicable): business name, tax ID, bank details for payouts</li>
                <li>Product listings: furniture descriptions, photos, pricing</li>
                <li>Performance data: sales history, customer ratings, response times</li>
                <li>Verification documents for identity confirmation</li>
              </ul>

              <h3 className="font-semibold text-gray-800 mb-3">From Buyers:</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Purchase history and transaction records</li>
                <li>Shipping preferences and delivery instructions</li>
                <li>Reviews and ratings provided for sellers</li>
                <li>Saved items and favorite sellers</li>
              </ul>
            </div>
          </section>

          {/* Section 2 - Updated for Platform Operations */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              2. How We Use Your Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-5 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <FontAwesomeIcon icon={faStore} className="text-blue-600 mr-2" />
                  Platform Operations
                </h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Facilitate transactions between buyers and sellers</li>
                  <li>Process payments through Razorpay and manage COD orders</li>
                  <li>Verify seller identities and maintain marketplace integrity</li>
                  <li>Coordinate furniture delivery and pickup logistics</li>
                  <li>Provide customer support and dispute resolution</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-5 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                  <FontAwesomeIcon icon={faUserShield} className="text-blue-600 mr-2" />
                  User Experience & Security
                </h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Personalize marketplace experience and recommendations</li>
                  <li>Monitor and prevent fraudulent activities</li>
                  <li>Improve platform features and user interface</li>
                  <li>Send transaction updates and important notifications</li>
                  <li>Generate anonymous analytics for business insights</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3 - Payment Processing */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              3. Payment Processing & Financial Data
            </h2>
            <div className="bg-blue-50 p-5 rounded-lg border border-blue-100">
              <div className="flex items-start mb-4">
                <FontAwesomeIcon icon={faCreditCard} className="text-blue-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold text-gray-800">Online Payments via Razorpay</h3>
                  <p className="text-gray-700 mt-1">
                    For online payments, we use Razorpay as our payment gateway. Zakku does not store 
                    your credit card details. All payment information is processed securely by Razorpay 
                    in compliance with PCI-DSS standards. We only receive confirmation of payment and 
                    basic transaction details.
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <h3 className="font-semibold text-gray-800 mb-2">Cash on Delivery (COD)</h3>
                <p className="text-gray-700">
                  For COD orders, we share your contact and delivery information with our delivery partners 
                  solely for order fulfillment purposes. Payment is collected directly by the delivery agent.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 - Data Sharing */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              4. Information Sharing in Our Marketplace
            </h2>
            <div className="space-y-4">
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Between Buyers and Sellers:</h3>
                <p className="text-gray-700">
                  To complete transactions, we share necessary contact and delivery information 
                  between transacting parties. This includes sharing buyer's delivery address 
                  with seller and seller's contact information with buyer.
                </p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">With Service Providers:</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-1">
                  <li>Delivery partners for furniture pickup and delivery</li>
                  <li>Payment processors (Razorpay) for online transactions</li>
                  <li>Customer support and communication tools</li>
                  <li>Analytics and security service providers</li>
                </ul>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Important:</h3>
                <p className="text-gray-700">
                  We do not sell or rent your personal information to third parties for marketing purposes. 
                  We only share data as necessary for marketplace operations and legal compliance.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 - Seller-Specific Information */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              5. For Sellers on Our Platform
            </h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded-r-lg">
              <h3 className="font-semibold text-gray-800 mb-2">Important Seller Notes:</h3>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Your contact information may be shared with buyers who purchase your items</li>
                <li>Business information is required for tax and payout purposes</li>
                <li>Product listings are public and visible to all platform users</li>
                <li>Performance metrics (ratings, response time) are displayed on your seller profile</li>
                <li>You are responsible for your product descriptions and customer communications</li>
              </ul>
            </div>
          </section>

          {/* Section 6 - Data Security */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              6. Data Security Measures
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-4 bg-green-50 rounded-lg border border-green-100">
                <h3 className="font-semibold text-gray-800 mb-3">Technical Security</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>SSL encryption for all data transmissions</li>
                  <li>Secure servers with regular security updates</li>
                  <li>Encrypted database storage for sensitive information</li>
                  <li>Regular security audits and vulnerability assessments</li>
                </ul>
              </div>
              <div className="p-4 bg-green-50 rounded-lg border border-green-100">
                <h3 className="font-semibold text-gray-800 mb-3">Operational Security</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Limited employee access to user data</li>
                  <li>Secure payment processing through Razorpay</li>
                  <li>Regular security training for our team</li>
                  <li>Incident response and breach notification procedures</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 7 - User Rights */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              7. Your Rights & Choices
            </h2>
            <div className="space-y-4">
              <div className="p-4 bg-purple-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Account Controls:</h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Access and download your personal data from account settings</li>
                  <li>Update or correct your profile information anytime</li>
                  <li>Control notification preferences and marketing communications</li>
                  <li>Delete your account (subject to transaction history retention requirements)</li>
                </ul>
              </div>
              <div className="p-4 bg-purple-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Data Retention:</h3>
                <p className="text-gray-700">
                  We retain your information as long as your account is active or as needed to provide services. 
                  Transaction records are kept for legal and accounting purposes. You may request deletion of 
                  certain personal data, but note that we may retain information required for legal compliance, 
                  dispute resolution, and marketplace integrity.
                </p>
              </div>
            </div>
          </section>

          {/* Section 8 - Cookies */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              8. Cookies & Tracking Technologies
            </h2>
            <p className="text-gray-700 mb-4">
              We use cookies and similar technologies to enhance your experience on our furniture marketplace:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Essential</h3>
                <p className="text-gray-700 text-sm">Required for platform functionality and security</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Performance</h3>
                <p className="text-gray-700 text-sm">Help us improve platform performance</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <h3 className="font-semibold text-gray-800 mb-2">Personalization</h3>
                <p className="text-gray-700 text-sm">Remember preferences and show relevant furniture</p>
              </div>
            </div>
            <p className="text-gray-700 mt-4">
              You can manage cookie preferences through your browser settings. Note that disabling certain 
              cookies may affect platform functionality.
            </p>
          </section>

          {/* Section 9 - Updates */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              9. Policy Updates
            </h2>
            <div className="bg-blue-50 p-5 rounded-lg">
              <p className="text-gray-700">
                We may update this Privacy Policy to reflect changes in our practices or legal requirements. 
                When we make significant changes, we will notify you through the platform or via email. 
                The updated policy will be effective immediately upon posting.
              </p>
              <div className="mt-4 p-3 bg-white rounded">
                <p className="text-gray-700">
                  <strong>Current Version:</strong> {lastUpdated}
                </p>
              </div>
            </div>
          </section>

          {/* Section 10 - Contact */}
          <section>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
              10. Contact Information
            </h2>
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-6 rounded-lg">
              <h3 className="font-semibold text-gray-800 mb-4">For Privacy Concerns:</h3>
              <div className="space-y-3">
                <p className="text-gray-700">
                  <strong>Email:</strong> privacy@zakku.com
                </p>
                <p className="text-gray-700">
                  <strong>Support:</strong> support@zakku.com
                </p>
                <p className="text-gray-700">
                  <strong>Sellers:</strong> sellers@zakku.com
                </p>
                {/* <p className="text-gray-700">
                  <strong>Address:</strong> Zakku Furniture Marketplace, [Your Office Address]
                </p> */}
              </div>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <p className="text-gray-700 text-sm">
                  We aim to respond to all privacy-related inquiries within 48 hours.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      
    </div>
  );
};

export default PrivacyPolicy;